import { render, staticRenderFns } from "./UpdateBusinessMemberDob.vue?vue&type=template&id=7f2ae59c"
import script from "./UpdateBusinessMemberDob.vue?vue&type=script&lang=js"
export * from "./UpdateBusinessMemberDob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports